import useSWRImmutable from 'swr/immutable';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { ComponentListType, ComponentService } from 'services/ComponentService';

const useProducts = (props: ComponentListType = {}, condition: boolean = true) => {
    const swr = useSWRImmutable(
        ...prepareConditionalSwrArgs({
            key: `/components?${JSON.stringify(props)}`,
            fetcher: () => {
                return ComponentService.list(props);
            },
            condition,
        }),
        {
            revalidateOnFocus: false,
            revalidateOnMount: true,
            keepPreviousData: true,
        },
    );

    return {
        ...swr,
        products: swr.data?.docs ?? [],
        totalDocs: swr.data?.totalDocs ?? 0,
    };
};

export { useProducts };
